import {SearchSelectOption} from '../../../../../../_metronic/helpers/components/SearchSelect'

type LoadedRowCurrency = {
  cur?: string | null
  curi?: number | null
  curt?: string | null
}

// «cur» is the currency code (USD); the currency list («نوع ارز») and the server's currencyId use the currency's id,
// which backend 1.0.0.787+ sends as «curi». Number(cur) went out as currencyId null and the server refused every edit of
// an export or currency-sale invoice with «نوع ارز ... الزامی است» (TT605).
export const loadedRowCurrency = (
  rw: LoadedRowCurrency
): {currency?: SearchSelectOption; currencyId?: number} => ({
  currency: rw.cur
    ? {
        label: rw.curt,
        value: rw.curi != null ? rw.curi.toString() : rw.cur,
      }
    : undefined,
  currencyId: rw.curi ?? undefined,
})
